import { CartService, CartServiceModule } from '@b2b/common/services';
import { ApiService } from '@b2b/common/services/api/types';
import { FeatureService, FeatureServiceModule } from '@b2b/common/services/feature/feature.service';
import { getFullName } from '@b2b/common/services/helpers';
import { TODO, UIBModalService } from '@b2b/types/core';
import { RecurringPaymentTransaction, SubscriptionDetail } from '@b2b/types/subscriptions';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';
import moment from 'moment-timezone';

SubscriptionsDetailController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$filter',
  '$uibModal',
  'SubscriptionData',
  'HelpersService',
  'ApiService',
  'FeatureService',
  'CartService',
  'MembershipService',
  'GridStateFactory',
  'GridDefinitionFactory',
];

function SubscriptionsDetailController(
  $scope: IScope & { subscriptionsDetail: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  $filter: IFilterService,
  $uibModal: UIBModalService,
  SubscriptionData: TODO,
  HelpersService: TODO,
  ApiService: ApiService,
  FeatureService: FeatureService,
  CartService: CartService,
  MembershipService: TODO,
  GridStateFactory: TODO,
  GridDefinitionFactory: TODO,
) {
  const ctrl = {
    title: 'Subscription Details',

    model: {} as Partial<SubscriptionDetail>,

    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),

    renewLoading: false,
    loading: false,
    isLoaded: false,

    recurringPaymentTransactions: [] as RecurringPaymentTransaction[],

    history: [] as Partial<RecurringPaymentTransaction>[],

    membership: {},

    optionsOverride: {
      data: 'subscriptionsDetail.history',
      rowClasses:
        "{ 'ui-grid-row-header-cell': col.isRowHeader, 'private-event': (row.entity.type === 'private') || row.entity.offSchedule, 'programs-list-canceled-row': (row.entity.showCanceledState && row.entity.isCanceled) }",
      columnDefs: [
        {
          field: 'recurringPaymentPlanId',
          displayName: 'Subscription ID',
          visible: true,
          enableSorting: false,
          cellTemplate:
            '<div class="ui-grid-cell--relative"><div class="ui-grid-cell-contents"><span data-ng-style="row.entity.colorCategoryStyle"></span> {{ row.entity.recurringPaymentPlanId }}</div></div>',
        },
        {
          field: 'originatingPlanId',
          displayName: 'Original Subscription ID',
          visible: false,
          enableSorting: false,
        },
        {
          field: 'updateType',
          displayName: 'Update Type',
          enableSorting: false,
          cellTemplate: '<div class="statusColumn">{{ row.entity.updateType }}</div>',
        },
        {
          field: 'updatedDate',
          displayName: 'Updated Date',
          enableSorting: false,
          cellTemplate: '<div>{{ row.entity.updatedDate }}</div>',
        },
        // {
        //   field: 'dbId',
        //   displayName: 'DB ID (Acme Membership)',
        //   enableSorting: false,
        //   cellTemplate:
        //     '<div><a data-ng-click="grid.appScope.onViewMembershipClick()"\n' +
        //     '               role="link">{{ COL_FIELD }}</a></div>',
        // },
        // {
        //   field: 'cardOnFile',
        //   displayName: 'Card On File',
        //   enableSorting: false,
        //   cellTemplate: '<div>{{ COL_FIELD }}</div>',
        // },
        {
          field: 'channel',
          displayName: 'Channel',
          enableSorting: false,
          cellTemplate: '<div>{{ row.entity.channel }}</div>',
        },
        {
          field: 'orderNumber',
          displayName: 'Order Number',
          enableSorting: false,
          cellTemplate:
            '<div><a data-ng-click="grid.appScope.onViewOrderClick(row)" role="link">{{ row.entity.orderNumber }}</a></div>',
        },
        {
          field: 'orderDate',
          displayName: 'Order Date',
          visible: false,
          enableSorting: false,
          cellTemplate: '<div>{{ row.entity.orderDate }}</div>',
        },
        {
          field: 'optinDate',
          displayName: 'Opt in Date',
          visible: false,
          enableSorting: false,
          cellTemplate: '<div>{{ row.entity.optinDate }}</div>',
        },
        {
          field: 'createdDate',
          displayName: 'Created Date',
          visible: false,
          enableSorting: false,
          cellTemplate: '<div>{{ row.entity.createdDate }}</div>',
        },
      ],
      appScopeProvider: {
        onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
          ctrl.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
        },
        onDataGridSortChange: function (grid, columns, page) {
          ctrl.onDataGridSortChange(grid, columns, page);
        },
        onViewMembershipClick: function () {
          ctrl.onViewMembershipClick(ctrl.membershipData.id);
        },
        onViewOrderClick: function (row) {
          ctrl.onViewOrderClick(row.entity.orderId);
        },
      },
    },

    overviewData: {
      status: '',
      statusChangeDate: '',
      subscriptionId: '',
      originalSubscriptionId: '',
      nextPaymentDate: '',
      nextPaymentAmount: '',
      cardOnFile: '',
      ccExpirationDate: '',
    },

    customerData: {
      id: '',
      name: '',
      email: '',
      phone: '',
      address: [],
      acmeCustomerNumber: '',
      externalCustomerNumber: '',
    },

    membershipData: {
      standing: '',
      expirationDate: '',
      levelName: '',
      offering: '',
      externalMembershipNumber: '',
      acmeMembershipNumber: '',
      id: '',
    },

    overviewDetails: {
      columns: 3,
      columnWidth: 4,
      layout: 'Z',
      data: 'subscriptionsDetail.overviewData',
      include: [
        'status',
        'nextPaymentDate',
        'cardOnFile',
        'statusChangeDate',
        'nextPaymentAmount',
        'ccExpirationDate',
        'originalSubscriptionId',
        'subscriptionId',
      ],
      mappings: {
        ccExpirationDate: 'Card on File Expiration',
      },
    },

    canceledOverviewDetails: {
      columns: 2,
      columnWidth: 4,
      layout: 'Z',
      data: 'subscriptionsDetail.overviewData',
      include: [
        'status',
        'cardOnFile',
        'statusChangeDate',
        'ccExpirationDate',
        'originalSubscriptionId',
        'subscriptionId',
      ],
      mappings: {
        ccExpirationDate: 'Card on File Expiration',
      },
    },

    failedTokenOverviewDetails: {
      columns: 2,
      columnWidth: 4,
      layout: 'N',
      data: 'subscriptionsDetail.overviewData',
      include: [
        'status',
        'statusChangeDate',
        'originalSubscriptionId',
        'subscriptionId',
        'nextPaymentDate',
        'nextPaymentAmount',
      ],
      mappings: {
        ccExpirationDate: 'Card on File Expiration',
      },
    },

    customerDetails: {
      columns: 1,
      columnWidth: 4,
      data: 'subscriptionsDetail.customerData',
      exclude: ['id', 'acmeCustomerNumber', 'externalCustomerNumber'],
      mappings: {
        name: 'Customer Name',
      },
    },

    customerNumbersDetails: {
      columns: 1,
      columnWidth: 4,
      data: 'subscriptionsDetail.customerData',
      include: ['acmeCustomerNumber', 'externalCustomerNumber'],
      mappings: {
        acmeCustomerNumber: 'ACME Customer Number',
      },
    },

    membershipDetails: {
      columns: 3,
      columnWidth: 4,
      data: 'subscriptionsDetail.membershipData',
      include: [
        'standing',
        'expirationDate',
        'levelName',
        'offering',
        'externalMembershipNumber',
        'acmeMembershipNumber',
      ],
      mappings: {
        standing: 'Membership Standing',
        expirationDate: 'Membership Expiration Date',
        levelName: 'Membership Level Name',
        offering: 'Membership Offering',
        acmeMembershipNumber: 'ACME Membership Number',
      },
    },

    enableCustomersOrgCheckout: false,

    gridName: $state.current.name + '.grid0',
    viewId: '',

    init: function () {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Subscription Details',
      });

      this.viewId = $state.current.name;

      this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

      this.initSubscriptionData();
    },

    initSubscriptionData: function () {
      if (SubscriptionData.data && SubscriptionData.data.success) {
        this.success.init(SubscriptionData);
      } else {
        this.error.init(SubscriptionData);
      }
    },

    initHeaderButtons: function () {
      const contentTitle = {
        title: ctrl.title,
        buttonLeft: {
          label: 'Back',
          action: function () {
            $state.go('application.subscriptions.list');
          },
        },
      };

      $scope.$emit('Application::contentTitleChange', contentTitle);
    },

    // OPTED_IN(1, "optedIn"),
    // AUTO_RENEW(2, "autoRenew"),
    // UPDATE_PAYMENT_METHOD(3, "updatePaymentMethod"),
    // CANCELED(4, "canceled"),
    // REPLACED(5, "replaced"),
    // NEW_RESULTED_FROM_REPLACE(6, "newResultedFromReplace"),
    // NEW_EXTERNAL(7, "newExternal"),
    // EFFECTIVE_DATE_CHANGE(8, "effectiveDateChange"),
    // AUTO_RENEW_EMAIL_SENT(9, "autoRenewEmailSent"),
    // OPTED_OUT(10, "optedOut");
    getUpdateType: function (triggeringEvent) {
      const updateTypes = {
        optedIn: 'Opted-In',
        autoRenew: 'Auto Renewed',
        updatePaymentMethod: 'Payment Method Updated',
        canceled: 'Canceled',
        replaced: 'Replaced',
        newResultedFromReplace: 'New Resulted From Replaced',
        newExternal: 'New External',
        effectiveDateChange: 'Date Changed',
        autoRenewEmailSent: 'Auto Renew Email Sent',
        optedOut: 'Opted-Out',
      };

      if (updateTypes.hasOwnProperty(triggeringEvent)) {
        return updateTypes[triggeringEvent];
      } else {
        return triggeringEvent;
      }
    },

    parseHistory: function (recurringPaymentTransactions) {
      const transactionHistory: Partial<RecurringPaymentTransaction>[] = [];
      for (let x = 0; x < recurringPaymentTransactions.length; x++) {
        const transaction: Partial<RecurringPaymentTransaction> = {};

        transaction.updateType = this.getUpdateType(recurringPaymentTransactions[x].triggeringEvent);
        transaction.dbId = ctrl.model.membership.membershipId;

        if (
          ctrl.model.hasOwnProperty('onfilePaymentMethod') &&
          transaction.updateType !== 'Opt-Out' &&
          recurringPaymentTransactions[x].onfilePaymentMethodId === ctrl.model.onfilePaymentMethod?.id
        ) {
          transaction.cardOnFile = ctrl.overviewData.cardOnFile + ' ' + ctrl.overviewData.ccExpirationDate;
        } else {
          transaction.cardOnFile = '';
        }
        transaction.colorCategoryStyle = ctrl.getColorCategoryStyle(recurringPaymentTransactions[x]);
        transaction.recurringPaymentPlanId = recurringPaymentTransactions[x].recurringPaymentPlanId;
        transaction.originatingPlanId = recurringPaymentTransactions[x].originatingPlanId;
        transaction.channel = recurringPaymentTransactions[x].saleChannel;
        transaction.orderNumber = recurringPaymentTransactions[x].orderNumber;
        transaction.orderDate = moment(recurringPaymentTransactions[x].transactionDate).format(
          HelpersService.dateFormats.shortDateAlt,
        );
        transaction.optinDate = moment(ctrl.model.recurringPaymentPlan?.currentTermStart).format(
          HelpersService.dateFormats.shortDateAlt,
        );
        transaction.createdDate = moment(recurringPaymentTransactions[x].createdOn).format(
          HelpersService.dateFormats.shortDateAlt,
        );
        transaction.updatedDate = moment(recurringPaymentTransactions[x].updatedOn).format(
          HelpersService.dateFormats.shortDateAlt,
        );
        transaction.orderId = recurringPaymentTransactions[x].orderId;

        transactionHistory.push(transaction);
      }
      ctrl.history = transactionHistory;
    },

    getColorCategoryStyle: function (transactionItem) {
      let backgroundColor = '#d1d1d1';

      if (transactionItem.recurringPaymentPlanId === ctrl.model.recurringPaymentPlan?.id) {
        backgroundColor = '#2291ff';
      }

      return Object.assign(
        {},
        {
          display: 'block',
          position: 'absolute',
          top: '-2px',
          left: '-2px',
          height: '100%',
          width: '4px',
          'background-color': backgroundColor,
        },
      );
    },

    showViewCustomerLink: function () {
      ctrl.enableCustomersOrgCheckout = FeatureService.isEnabled(FeatureService.customers);
    },

    onOptOutClick: function () {
      const optOutConfirmModal = $uibModal.open({
        templateUrl: 'views/application/views/subscriptions/modals/confirmOptOutModal.tpl.html',
        size: 'md',
        controller: 'OptOutModalControler',
        resolve: {
          memberName: () => ctrl.customerData.name,
        },
      });

      optOutConfirmModal.result
        .then(() => {
          ApiService.subscriptions
            .optOut(ctrl.overviewData.subscriptionId)
            .then(() => {
              // Refresh page
              $state.reload();
            })
            .catch(() => {
              // noop
            });
        })
        .catch(() => {
          // Dismiss
        });
    },

    onViewCustomerClick: function (id) {
      $state.go('application.customers.individuals.detail', { id: id });
    },

    onViewMembershipClick: function (id) {
      $state.go('application.membership.detail', { id: id });
    },

    onViewOrderClick: function (id) {
      $state.go('application.orders.detail.summary', { orderId: id });
    },

    onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
      const self = ctrl;
      self.gridState.updateGridState(newPage, pageSize);
      if (sortField) {
        self.gridState.updateGridState(null, null, sortField, null);
      }
      if (sortDirection) {
        self.gridState.updateGridState(null, null, null, sortDirection);
      }

      self.initSubscriptionData();
    },

    onDataGridSortChange: function (grid, columns, page) {
      const self = ctrl;
      const data = columns[0];
      self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);

      self.initSubscriptionData();
    },

    formatCustomerAddress: function (address) {
      let formattedAddress;
      if (address) {
        if (address.streetAddress1) {
          formattedAddress = address.streetAddress1 + ',';
        }

        if (address.streetAddress2) {
          formattedAddress = formattedAddress + ' ' + address.streetAddress2 + ',';
        }

        if (address.city) {
          formattedAddress = formattedAddress + ' ' + address.city + ',';
        }

        if (address.state) {
          formattedAddress = formattedAddress + ' ' + address.state;
        }

        if (address.zipCode) {
          formattedAddress = formattedAddress + ' ' + address.zipCode;
        }

        if (address.country) {
          formattedAddress = formattedAddress + ' ' + address.country;
        }
      }

      return formattedAddress;
    },

    isvalidOptOut: function () {
      return !(
        ctrl.overviewData.status === 'active' ||
        ctrl.overviewData.status === 'tokenCreationFailed' ||
        ctrl.overviewData.status === 'failed' ||
        ctrl.overviewData.status === 'pending' ||
        ctrl.overviewData.status === 'noPaymentMethod'
      );
    },

    getNextPayment: function () {
      let nextPayment = this.model.membership.price / 100;
      if (this.model.membershipOffering) {
        if (this.model.membership.pricePointId) {
          if (
            this.model.membershipOffering.priceLists instanceof Array &&
            this.model.membershipOffering.priceLists.length &&
            this.model.membershipOffering.priceLists[0].prices instanceof Array &&
            this.model.membershipOffering.priceLists[0].prices.length
          ) {
            for (let i = 0, ii = this.model.membershipOffering.priceLists[0].prices.length; i < ii; i++) {
              if (
                this.model.membershipOffering.priceLists[0].prices[i].personType.id ===
                this.model.membership.pricePointId
              ) {
                nextPayment = parseFloat(this.model.membershipOffering.priceLists[0].prices[i].price);
                break;
              }
            }
          }
        }
      }
      return nextPayment;
    },

    renewMembership: function (options: { showOptions: boolean }) {
      const membership: {
        quantity: any;
        itemType: any;
        membershipId: any;
        orderContactId: any;
        categoryId: any;
        membershipCategory: any;
        offeringId: any;
        offeringName: any;
        pricePointId: any;
        amount?: any;
      } = {
        quantity: 1,
        itemType: MembershipService.getPurchaseType('renew'),
        membershipId: ctrl.model.membership.id,
        orderContactId: ctrl.model.customer?.id,
        categoryId: ctrl.model.membership.membershipLevelId,
        membershipCategory: ctrl.model.membership.membershipLevelName,
        offeringId: ctrl.model.membershipOffering?.id,
        offeringName: ctrl.model.membershipOffering?.name,
        pricePointId: ctrl.model.membership.pricePointId,
      };

      if (ctrl.renewLoading) {
        return;
      }

      ctrl.loading = true;

      CartService.memberships
        .lifecycle(CartService.memberships.ENUMS.renew, {
          membershipId: membership.membershipId,
          membershipCategory: membership.membershipCategory,
          membershipName: [ctrl.model.customer?.firstName, ctrl.model.customer?.lastName].filter(Boolean).join(' '),
        })
        .then(function (response) {
          const found = CartService.memberships.hasPricepointMatch(membership, response.data.payload);
          if (!options.showOptions && found) {
            membership.amount = found.pricepoint.price;
            membership.itemType = MembershipService.getPurchaseType(found.type || 'renew');
            ctrl.updateOrderContact(function () {
              CartService.memberships.addToCart(membership).then(ctrl.success.updateCart, ctrl.error.updateCart);
            });
          } else {
            ctrl.updateOrderContact(function () {
              ctrl.loading = false;
              ctrl.goToState('application.membership.retail');
            });
          }
        }, this.error.renewMembership);
    },

    updateOrderContact: function (callBack) {
      const hasNewMembershipPurchase = !!CartService.memberships.hasNewMembership();
      const customer = this.model.customer;
      const showPrompt =
        (CartService.hasOrderContact() && !CartService.isOrderContact(customer.customerId)) || hasNewMembershipPurchase;
      let message;

      if (showPrompt) {
        if (hasNewMembershipPurchase) {
          message = 'Continuing will remove any memberships in the cart.';
        } else if (!customer.id) {
          message =
            'Do you want to change the transacting member from ' +
            getFullName(CartService.getOrderContact()) +
            '?' +
            '<br><br>Doing so will remove any memberships in the cart.';
        } else {
          message =
            'Do you want to transact as ' +
            getFullName(customer) +
            ' instead of ' +
            getFullName(CartService.getOrderContact()) +
            '? ' +
            '<br><br>Doing so will remove any memberships in the cart.';
        }

        this.showMessage(
          'Are you sure?',
          message,
          'Continue',
          function (response) {
            CartService.cancelCart().then(function () {
              ctrl.updateContactAndProceed(callBack);
            });
          },
          function () {
            //do nothing
          },
        );
      } else {
        this.updateContactAndProceed(callBack);
      }
    },

    updateContactAndProceed: function (callBack) {
      CartService.memberships
        .updateOrderContact({
          membershipId: this.model.membership.id,
          cardholders: this.membership.cardholders,
          orderContactId: this.model.customer.id,
        })
        .then(callBack, this.error.renewMembership);
    },

    showMessage: function (
      title: string,
      message: string,
      okText?: string,
      successCallback?: () => void,
      errorCallback?: () => void,
    ) {
      if (message) {
        const showMessageModal = $uibModal.open({
          size: 'md',
          controller: 'ConfirmModalController',
          templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
          resolve: {
            modalTitle: () => title,
            modalMessage: () => message,
            okText: () => okText || 'Done',
          },
        });
        // Invoked when modal completes with close(params)
        showMessageModal.result.then(
          function () {
            if (typeof successCallback === 'function') {
              successCallback();
            }
          },
          function () {
            if (typeof errorCallback === 'function') {
              errorCallback();
            }
          },
        );
      }
    },

    goToState: function (state) {
      const props = {
        membershipId: this.model.membership.id,
        orderContactId: this.model.customer.id,
      };

      $state.go(state, props);
    },

    getMembership: function () {
      this.renewLoading = true;
      ApiService.membership.detail(this.model.membership.id).then(this.success.getMembership, this.error.getMembership);
    },

    success: {
      init: function (response) {
        $timeout(function () {
          let paymentMethodBrand = '';
          let ccLastFourDigits = '';
          let holderName = '';
          let ccExpirationDate = '';

          ctrl.model = response.data.payload;

          ctrl.getMembership();

          if (ctrl.model.onfilePaymentMethod) {
            paymentMethodBrand = ctrl.model.onfilePaymentMethod.paymentMethodBrand;
            ccLastFourDigits = ctrl.model.onfilePaymentMethod.ccLastFourDigits;
            holderName = ctrl.model.onfilePaymentMethod.holderName;
            ccExpirationDate =
              ctrl.model.onfilePaymentMethod.ccExpirationMonth + '/' + ctrl.model.onfilePaymentMethod.ccExpirationYear;
          }

          ctrl.overviewData.status = ctrl.model.recurringPaymentPlan?.status ?? '';
          ctrl.overviewData.subscriptionId = ctrl.model.recurringPaymentPlan?.id;

          ctrl.overviewData.originalSubscriptionId =
            ctrl.model.recurringPaymentPlan?.id !== ctrl.model.recurringPaymentPlan?.originatingPlanId
              ? ctrl.model.recurringPaymentPlan?.originatingPlanId
              : '';
          ctrl.overviewData.nextPaymentDate = ctrl.model.recurringPaymentPlan?.nextPaymentDate
            ? moment(ctrl.model.recurringPaymentPlan.nextPaymentDate).format(HelpersService.dateFormats.standardDateAlt)
            : '';
          ctrl.overviewData.nextPaymentAmount = $filter('currency')(ctrl.getNextPayment());
          ctrl.overviewData.cardOnFile = paymentMethodBrand + ' ' + 'x' + ccLastFourDigits + ' ' + holderName;
          ctrl.overviewData.statusChangeDate = ctrl.model.recurringPaymentPlan?.statusChangeDate
            ? moment(ctrl.model.recurringPaymentPlan.statusChangeDate).format(
                HelpersService.dateFormats.standardDateAlt,
              )
            : '';
          ctrl.overviewData.ccExpirationDate = ccExpirationDate;

          if (ctrl.model.customer) {
            ctrl.customerData.name = ctrl.model.customer.firstName + ' ' + ctrl.model.customer.lastName;
            ctrl.customerData.email = ctrl.model.customer.email;
            ctrl.customerData.phone = ctrl.model.customer.phoneNumber;
            ctrl.customerData.address = ctrl.formatCustomerAddress(ctrl.model.customer.address[0]);
            ctrl.customerData.acmeCustomerNumber = ctrl.model.customer.customerId;
            ctrl.customerData.id = ctrl.model.customer.id;
            ctrl.customerData.externalCustomerNumber = ctrl.model.customer.externalCustomerImportId;
          }

          ctrl.membershipData.standing = ctrl.model.membership.membershipStanding;
          ctrl.membershipData.expirationDate = ctrl.model.membership.membershipExpirationDate
            ? moment(ctrl.model.membership.membershipExpirationDate).format(HelpersService.dateFormats.standardDateAlt)
            : '';
          ctrl.membershipData.levelName = ctrl.model.membership.membershipLevelName;
          ctrl.membershipData.offering = ctrl.model.membershipOffering?.name ?? '';
          ctrl.membershipData.externalMembershipNumber = ctrl.model.membership.externalMembershipId;
          ctrl.membershipData.acmeMembershipNumber = ctrl.model.membership.membershipId;
          ctrl.membershipData.id = ctrl.model.membership.id;

          ctrl.parseHistory(ctrl.model.recurringPaymentTransactions);

          ctrl.isLoaded = true;
          ctrl.gridDefinition.isLoaded = true;
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: ctrl.gridDefinition.options.gridName,
            datasetLength: ctrl.history.length,
            totalItems: ctrl.history.length,
          });
        }, 0);

        ctrl.initHeaderButtons();
        ctrl.showViewCustomerLink();
      },

      updateCart: function (response) {
        ctrl.loading = false;
        $scope.$emit('Cart::Open');
      },

      getMembership: function (response) {
        ctrl.membership = response.data.payload;
        ctrl.renewLoading = false;
      },
    },

    error: {
      init: function (response) {
        ctrl.isLoaded = false;
        ctrl.initHeaderButtons();
      },
      updateCart: function (response) {
        ctrl.isLoaded = false;
        ctrl.showMessage('An error occurred', 'Unable to update cart');
      },
      renewMembership: function (response) {
        ctrl.isLoaded = false;
        ctrl.showMessage('An error occurred', response.data.error);
      },

      getMembership: function (response) {
        ctrl.renewLoading = false;
      },
    },
  };

  $scope.subscriptionsDetail = ctrl;
  ctrl.init();
}

export const SubscriptionsDetailControllerModule = angular
  .module('acme.view.application.subscriptions.detail.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.userPreferences',
    FeatureServiceModule,
    CartServiceModule,
    'acme.common.service.membership',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
  ])
  .controller('SubscriptionsDetailController', SubscriptionsDetailController).name;
